import React from 'react';
import { motion } from 'framer-motion';
import { PackageIcon, UsersIcon, WalletIcon, WrenchIcon, FileCheckIcon } from 'lucide-react';
export function About() {
  const useCases = [{
    icon: PackageIcon,
    title: 'Secure Inventory',
    description: 'Grab stock before your competitor does.'
  }, {
    icon: UsersIcon,
    title: 'Scale Your Team',
    description: "Hire the talent who'll 10x your output."
  }, {
    icon: WalletIcon,
    title: 'Bridge Cash Flow',
    description: 'Cover payroll while waiting on receivables.'
  }, {
    icon: WrenchIcon,
    title: 'Upgrade Equipment',
    description: "Replace the gear that's holding you back."
  }, {
    icon: FileCheckIcon,
    title: 'Seize Contracts',
    description: 'Say YES to the deal sitting on your desk.'
  }];
  return <section id="about" className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black" data-id="element-21">
      <div className="max-w-7xl mx-auto" data-id="element-22">
        <div className="max-w-5xl mx-auto" data-id="element-23">
          <div className="mb-12" data-id="element-24">
            <h2 className="text-4xl font-bold text-white mb-6" data-id="element-25">
              Your Business Deserves Funding
            </h2>
            <p className="text-lg text-zinc-300 max-w-3xl" data-id="element-26">
              You're running a real business. Doing real revenue. Managing real
              cash flow. And you need capital to grow.
            </p>
          </div>

          {/* Interactive Use Cases Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-27">
            {useCases.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(255, 255, 255, 0.1)',
            borderColor: 'rgba(255,255,255,0.2)'
          }} className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800 backdrop-blur-sm hover:bg-zinc-900 transition-colors group cursor-default" data-id="element-28">
                <div className="w-12 h-12 bg-black rounded-lg flex items-center justify-center mb-4 border border-zinc-800 group-hover:border-zinc-700 transition-colors" data-id="element-29">
                  <item.icon className="w-6 h-6 text-white" data-id="element-30" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-31">
                  {item.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-32">
                  {item.description}
                </p>
              </motion.div>)}
          </div>

          <div className="max-w-4xl" data-id="element-33">
            <p className="text-lg text-zinc-300 mb-4" data-id="element-34">
              Banks make you wait 6-8 weeks while the opportunity vanishes.
            </p>
            <p className="text-lg text-white font-bold mb-4" data-id="element-35">
              We get you funded in 72 hours.
            </p>
            <p className="text-lg text-white font-bold mb-6" data-id="element-36">
              $127M deployed to operators who couldn't wait.
            </p>
            <p className="text-lg text-zinc-300 mb-6" data-id="element-37">
              We look at your business performance, not your credit history. We
              fund based on your cash flow today, not what happened 3 years ago.
            </p>
            <p className="text-lg text-zinc-300 mb-6" data-id="element-38">
              If you're running a solid operation and need capital this week to
              seize an opportunity or solve a problem we're built for this exact
              moment.
            </p>
            <p className="text-lg text-zinc-300 italic border-l-4 border-white pl-4 py-1" data-id="element-39">
              The question isn't whether we can help. It's whether you can
              afford to wait.
            </p>
          </div>
        </div>
      </div>
    </section>;
}